import cx from "classnames";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { useAppService } from "../../hooks/use-app-service";
import { getEmbeddedSectionDetailPageRoute } from "../../_pages/embedded-section-detail.page";
import { EmbeddedSectionService } from "../../_service/embedded-section.service";
import UIcon from "../uicon-component";

function EmbeddedSectionLinksComponent({ user, community, history }) {
  const [sections, setSections] = useState([]);
  const [isSectionDataLoading, setIsSectionDataLoading] = useState(false);

  const [selectedLink, setSelectedLink] = useState(window.location.pathname);

  const communityId = community?.id ?? null;

  // get all the sections
  useEffect(() => {
    if (communityId) {
      setIsSectionDataLoading(true);
      EmbeddedSectionService.getEmbeddedSections(communityId)
        .then(({ embeddedSections }) => {
          setSections(embeddedSections);
        })
        .finally(() => {
          setIsSectionDataLoading(false);
        });
    }
  }, [communityId]);

  // listen for tab change
  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      // check if part of group, (just check the last part of the url)
      setSelectedLink(location.pathname);
    });

    return () => {
      unlisten();
    };
  }, [history]);

  if (!community) {
    return <></>;
  }

  if (isSectionDataLoading) {
    return <SectionTileShimmer />;
  }

  return (
    <div
      className={cx("my-3 py-3 border-t theme-border-default", {
        "border-b": sections.length,
      })}>
      {sections.map((section) => (
        <SectionLink
          section={section}
          key={section.id}
          selectedLink={selectedLink}
        />
      ))}
    </div>
  );
}

function SectionTileShimmer() {
  return (
    <div className="container flex-grow flex flex-col pt-0 animate-pulse py-2">
      <div className="h-6 ml-6 my-1 mr-6 bg-gray-300 rounded" />
      <div className="h-6 ml-6 my-1 mr-6 bg-gray-300 rounded" />
      <div className="h-6 ml-6 my-1 mr-6 bg-gray-300 rounded" />
    </div>
  );
}

function SectionLink({ section, selectedLink }) {
  const activePath = selectedLink;
  const { analyticsService } = useAppService();

  const sectionLink = getEmbeddedSectionDetailPageRoute(section.slug);

  const isActive = activePath === sectionLink;

  return (
    <NavLink
      exact={true}
      onClick={() =>
        analyticsService.track("embedded-channel-clicked", {
          embedName: section.name,
        })
      }
      strict
      to={sectionLink}
      className={cx(
        "sidebar-heading-holder flex items-center px-4 py-2 mx-2 rounded cursor-pointer",
        {
          "theme-bg-primary theme-text-on-primary": isActive,
          "theme-text-heading-1": !isActive,
        }
      )}>
      <div className="sidebar-heading font-bold pr-3 space-x-3 flex items-center ">
        <UIcon icon="notebook" className="text-lg h-7" />
        <span>{section.name}</span>
      </div>
    </NavLink>
  );
}

const EmbeddedSectionLinks = withRouter(
  connect((s) => ({
    user: s.auth,
    community: s.community,
  }))(EmbeddedSectionLinksComponent)
);

export default EmbeddedSectionLinks;
